import React from 'react';

import { H3, Paragraph } from 'DesignLibrary/atoms';

const MtmError = () => {
  return (
    <>
      <H3>Oops...</H3>
      <Paragraph>It looks like we have encountered an error.</Paragraph>
    </>
  );
};

export default MtmError;
